/*
 * Lightora : rappel de l'offre lot dans le panier
 * 1 luminaire éligible au panier : "Ajoutez-en un 2e : -5 % sur les deux"
 * 2 luminaires éligibles : "Ajoutez-en un 3e : -10 % sur les trois"
 * Le bouton n'apparaît que si tous les luminaires éligibles sont sur une même ligne :
 * il passe alors cette ligne à la quantité suivante via le panier du thème.
 * Rien ici ne touche au bouton de paiement : en cas d'erreur, le message ne s'affiche simplement pas.
 */
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const NUDGE_CLASS = 'lt-lot-cart-nudge';
  const CART_TARGETS = [
    { selector: '#CartDrawer .drawer__footer', position: 'afterbegin', items: 'cart-drawer-items' },
    { selector: '#main-cart-footer .cart__blocks', position: 'afterbegin', items: 'cart-items' },
  ];
  const WORDS = { 2: 'les deux', 3: 'les trois' };

  function getCart() {
    return fetch(`${root}cart.js`, { credentials: 'same-origin' }).then((response) => response.json());
  }

  function formatMoney(cents, format) {
    const amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/<[^>]*>/g, '');
  }

  function initCartNudge() {
    const config = window.lightoraLot;
    if (!config) return;

    let offer = null;
    let signature = null;
    let timer = null;

    // Les lignes techniques de personnalisation (_for) ne sont pas des luminaires
    function isEligible(item) {
      return config.types.includes(item.product_type) && !(item.properties && item.properties._for);
    }

    // Shopify applique la remise par article, arrondie au centime inférieur
    function computeOffer(cart) {
      const lines = cart.items
        .map((item, index) => ({ item, line: index + 1 }))
        .filter(({ item }) => isEligible(item));
      const units = lines.reduce((total, { item }) => total + item.quantity, 0);
      const next = units + 1;
      const discount = config.discounts[next];
      if (!discount) return null;

      const single = lines.length === 1 ? lines[0] : null;
      const saving = single ? Math.floor((single.item.original_price * discount) / 100) * next : 0;
      return { next, discount, line: single ? single.line : null, saving };
    }

    function cartSignature() {
      return ['#cart-icon-bubble', '#CartDrawer .totals__subtotal-value', '#main-cart-footer .totals__total-value']
        .map((selector) => {
          const element = document.querySelector(selector);
          return element ? element.textContent.trim() : '';
        })
        .join('|');
    }

    function buildNudge(itemsSelector) {
      const box = document.createElement('div');
      const text = document.createElement('p');
      const title = document.createElement('strong');
      box.className = NUDGE_CLASS;
      text.className = `${NUDGE_CLASS}__text`;
      title.textContent = `Ajoutez-en un ${offer.next}e : -${offer.discount} % sur ${WORDS[offer.next]}`;
      text.append(title);

      if (offer.saving) {
        const detail = document.createElement('span');
        detail.textContent = `soit ${formatMoney(offer.saving, config.moneyFormat)} d’économie`;
        text.append(detail);
      }
      box.append(text);

      const items = document.querySelector(itemsSelector);
      if (offer.line && items && typeof items.updateQuantity === 'function') {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `${NUDGE_CLASS}__button`;
        button.textContent = '+ Ajouter';
        button.addEventListener('click', () => {
          button.disabled = true;
          items.updateQuantity(offer.line, offer.next);
        });
        box.append(button);
      }
      return box;
    }

    function render() {
      CART_TARGETS.forEach(({ selector, position, items }) => {
        const target = document.querySelector(selector);
        if (!target) return;
        const existing = target.querySelector(`.${NUDGE_CLASS}`);
        if (existing && existing.dataset.offer === JSON.stringify(offer)) return;
        if (existing) existing.remove();
        if (!offer) return;
        const nudge = buildNudge(items);
        nudge.dataset.offer = JSON.stringify(offer);
        target.insertAdjacentElement(position, nudge);
      });
    }

    function sync() {
      const current = cartSignature();
      if (current === signature) {
        render();
        return;
      }
      signature = current;
      getCart()
        .then((cart) => {
          offer = computeOffer(cart);
          render();
        })
        .catch(() => {});
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(sync, 300);
    }

    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartNudge);
  } else {
    initCartNudge();
  }
})();
